import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArQA: CultureInfo = {
  name: 'ar-QA',
  displayName: 'Arabic (Qatar)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-QA',
  parent: CultureInfoAr
};
